import {
  getThresholdColor,
  getThresholdSizes,
  ThresholdGeometryProps,
} from "./shared";
import React, { FunctionComponent as FC } from "react";

/** Dashed verticals at each size threshold. */
export const ThresholdDividers: FC<ThresholdGeometryProps> = ({
  bands,
  chartPadding: { top: plotTop },
  displaySizes,
  plotHeight,
  xScale,
}) => {
  const sizes = getThresholdSizes(bands, displaySizes);
  return sizes.map((threshold, index) => {
    const color = getThresholdColor(bands, index);
    const x = xScale(threshold);
    return (
      <line
        key={bands[index]?.label ?? threshold}
        x1={x}
        x2={x}
        y1={plotTop}
        y2={plotTop + plotHeight}
        stroke={color}
        strokeWidth={1}
        strokeDasharray="4 4"
        pointerEvents="none"
      />
    );
  });
};
